export default __webpack_public_path__ + "static/media/drones.d68a9c64.jpg";